<template>
  <div class="aifv-pie">
    <div class="list-view-titel">
      <div class="list-view-vertical"></div>
      <div class="list-view-subtitel">AIFV</div>
    </div>
    <RadarChart :initData="aifvData" :titlePosition="'0'" :isNationwide="true"></RadarChart>
    <div class="list-table" v-if="aifvFileData">
      <div class="tilte-txt">
        AIFV房颤手术报告量: <span class="num">{{ aifvFileData && aifvFileData.length }}</span>
      </div>
      <div class="table-tr th">
        <div class="table-th table-td">季度</div>
        <div class="table-th table-td">日期</div>
        <div class="table-th table-td">类型</div>
        <div class="table-th table-td">AIFV</div>
      </div>
      <div class="table-tr tr" v-for="(item, index) in aifvFileData" :key="index">
        <div class="table-td">{{ item && item.quarter }}</div>
        <div class="table-td">{{ item.operationTime.substring(0, 10) }}</div>
        <div class="table-td">{{ item && item.operationType }}</div>
        <div class="table-td" @click="handleJumpPDF(item)">
          {{ item && item.operationScore }} >>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RadarChart from '@/components/RadarChart.vue'
import { getAIFVReport, getAIFVFileList } from '@/api/aifv'
import { updateIsRead } from '@/api/api'
export default {
  name: 'AIFV',
  components: {
    RadarChart
  },
  data () {
    return {
      aifvData: {},
      aifvFileData: [],
      source: {
        provinceAvgAifv: {
          aifv1: 0,
          aifv2: 0,
          aifv3: 0,
          aifv4: 0,
          aifv5: 0,
          aifv6: 0
        }
      }
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  methods: {
    getAIFVInfo () {
      if (!this.userInfo.multiCode) return
      let params = {
        multiCode: this.userInfo.multiCode
        // multiCode: 'MULD100000146'
      }
      getAIFVReport(params)
        .then(res => {
          console.log('getAIFVInfo res', res)
          if (res && res.data) {
            let obj1 = JSON.parse(JSON.stringify(res.data))
            const keyMap = {
              currentAifv: 'currentAifv',
              nationalAverageAifv: 'countryAvgAifv',
              preAifv: 'prevAifv'
            }
            // 更改键名
            let obj2 = Object.keys(obj1).reduce((newData, key) => {
              let newKey = keyMap[key] || key
              newData[newKey] = obj1[key]
              return newData
            }, {})
            // 更改键值
            for (const i in obj2) {
              if (Object.hasOwnProperty.call(obj2, i)) {
                const element = obj2[i]
                for (let j in element) {
                  if (j === 'id') {
                    element[j] = element[j] || ''
                  } else {
                    element[j] = Number(element[j]) || 0
                  }
                }
              }
            }
            // console.log('newObject', obj2)
            this.aifvData = JSON.parse(JSON.stringify(obj2))
            this.aifvData = Object.assign(this.aifvData, this.source)
          }
        })
        .catch(err => {
          console.log('getAIFVReport error', err)
        })
    },
    getAIFVFileData () {
      if (!this.userInfo.multiCode) return
      let params = {
        multiCode: this.userInfo.multiCode,
        pageSize: 50
        // multiCode: 'MULD10000336031'
      }
      getAIFVFileList(params)
        .then(res => {
          console.log('getAIFVFileList res', res)
          if (res && res.data) {
            if (res.data.list && res.data.list.length > 0) {
              this.aifvFileData = JSON.parse(JSON.stringify(res.data.list))
              this.aifvFileData.forEach(item => {
                item.createTime = this.$moment(parseInt(item.createTime)).format('YYYY-MM-DD')
                item.operationTime = this.$moment(parseInt(item.operationTime)).format('YYYY-MM-DD')
                item.updateTime = this.$moment(parseInt(item.updateTime)).format('YYYY-MM-DD')
              })
            }
          }
        })
        .catch(err => {
          console.log('getAIFVFileList error', err)
        })
    },
    handleJumpPDF (item) {
      updateIsRead({
        operationId: item.id
      }).then(res => {
        this.$router.push({
          path: '/pdfView',
          query: {
            code: item.fileId
          }
        })
      })
    }
  },
  mounted () {
    this.getAIFVInfo()
    this.getAIFVFileData()
  }
}
</script>

<style lang='less' scoped>
.aifv-pie {
  width: 375px;
  background-color: #f0f1f6;
  display: flex;
  flex-wrap: wrap;
  max-width: 100vw;
  overflow-x: hidden;

  .list-view-titel {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 20px 15px 16px 15px;
    // flex-wrap: wrap;
    align-content: center;
    position: relative;

    .list-view-vertical {
      width: 4px;
      height: 12px;
      background-color: #fe6a23;
      border: 1px solid #fe6a23;
      border-radius: 2px;
      margin-right: 7px;
    }

    .list-view-subtitel {
      display: flex;
      width: 80px;
      font-size: 15px;
      font-weight: 800;
      color: #1f333f;
      line-height: 15px;
    }

    .list-view-buttonlist {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      margin-left: 20px;

      .list-view-button {
        display: inline-block;
        width: 40px;
        font-size: 12px;
        background: #ffffff;
        border: 1px solid #ffffff;
        border-radius: 5px;
        text-align: center;
      }

      .list-view-buttonclick {
        color: #fe6a23;
        display: inline-block;
        width: 40px;
        font-size: 12px;
        background: #ffffff;
        border: 1px solid #ffffff;
        border-radius: 5px;
        text-align: center;
      }
    }
  }

  .list-view-btop {
    width: 375px;
    background: #ffffff;
    box-shadow: 2px 3px 10px 0 rgba(0, 0, 0, 0.04);
    border-radius: 5px;

    .list-view-buttonlist {
      text-align: center;

      .tips {
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        top: -10px;

        .tips-img {
          width: 12px;
          height: 13px;
          margin-right: 2px;
        }

        .tips-txt {
          font-size: 12px;
          color: #EB1700;
        }
      }

      .list-view-leftbutton {
        color: #EB1700;
        display: inline-block;
        width: 54px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        background: #ffffff;
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
        border-left: 1px solid #EB1700;
        border-top: 1px solid #EB1700;
        border-bottom: 1px solid #EB1700;
        text-align: center;
      }

      .list-view-leftbuttonclick {
        color: #ffffff;
        display: inline-block;
        width: 54px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        background: #EB1700;
        border-left: 1px solid #EB1700;
        border-top: 1px solid #EB1700;
        border-bottom: 1px solid #EB1700;
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
        text-align: center;
      }

      .list-view-midbutton {
        color: #EB1700;
        display: inline-block;
        width: 54px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        background: #ffffff;
        border: 1px solid #EB1700;
        text-align: center;
      }

      .list-view-midbuttonclick {
        color: #ffffff;
        display: inline-block;
        width: 54px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        background: #EB1700;
        border: 1px solid #EB1700;
        text-align: center;
      }

      .list-view-midtwobutton {
        color: #EB1700;
        display: inline-block;
        width: 54px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        background: #ffffff;
        border-top: 1px solid #EB1700;
        border-bottom: 1px solid #EB1700;
        border-right: 1px solid #EB1700;
        text-align: center;
      }

      .list-view-midtwobuttonclick {
        color: #ffffff;
        display: inline-block;
        width: 54px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        background: #EB1700;
        border-top: 1px solid #EB1700;
        border-bottom: 1px solid #EB1700;
        border-right: 1px solid #EB1700;
        text-align: center;
      }

      .list-view-rightbutton {
        color: #EB1700;
        display: inline-block;
        width: 54px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        background: #ffffff;
        border-right: 1px solid #EB1700;
        border-top: 1px solid #EB1700;
        border-bottom: 1px solid #EB1700;
        border-top-right-radius: 12px;
        border-bottom-right-radius: 12px;
        text-align: center;
      }

      .list-view-rightbuttonclick {
        color: #ffffff;
        display: inline-block;
        width: 54px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
        background: #EB1700;
        border-right: 1px solid #EB1700;
        border-top: 1px solid #EB1700;
        border-bottom: 1px solid #EB1700;
        border-top-right-radius: 12px;
        border-bottom-right-radius: 12px;
        text-align: center;
      }
    }

    .list-view-bottom {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 16px 16px 16px 16px;
      flex-wrap: wrap;
      align-content: center;
      position: relative;

      .list-view-tips {
        display: flex;
        justify-content: flex-end;
        width: 319px;
        font-size: 12px;
        font-weight: 500;
        color: #1f333f;
        line-height: 11px;

        .list-view-roundf {
          line-height: 11px;
          display: flex;
          align-items: center;

          .list-view-round {
            width: 7px;
            height: 7px;
            background: #ffffff;
            border-radius: 50%;
            border: 2px solid #EB1700;
            margin-right: 8px;
          }
        }
      }
    }

    .stuPieDomDiv {
      width: 375px;
      height: 441px;
      background: #ffffff;

      .stuPieDom {
        width: 375px;
        height: 441px;
        text-align: center;
        background: #ffffff;
        border-radius: 5px;
      }
    }
  }

  .list-table {
    background-color: #fff;
    margin-top: 8px;
    padding: 0 6px;
    box-sizing: border-box;
    width: 100%;

    .tilte-txt {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #2b2b2b;
      font-weight: 600;
      height: 60px;

      .num {
        font-size: 22px;
        color: #2b2b2b;
        font-weight: bold;
        margin-left: 10px;
      }
    }

    .table-tr {
      display: flex;
      align-items: center;
      height: 32px;
      padding-left: 10px;
      box-sizing: border-box;
      margin-bottom: 12px;
      justify-content: space-between;

      &.th {
        background-color: #f0f1f6;
      }

      &.tr {
        height: 14px;
        line-height: 14px;
        margin-bottom: 16px;
      }

      .table-td {
        font-size: 10px;
        color: #2b2b2b;
        font-weight: 400;
        width: 25%;

        &:nth-last-child(1) {
          width: 50px;
        }

        &.table-th {
          font-size: 12px;
        }
      }
    }
  }
}</style>



// WEBPACK FOOTER //
// src/views/AIFV/AIFV copy.vue